import httpcommonFile from "../baseUrl/httpcommonFile";

const myFiles = ({ id, name }) => {
  debugger;
  return httpcommonFile.get(`/api/files/user/${id}/files/search?name=${name}`);
};

const deleteFiles = (fileId) => {
  return httpcommonFile.delete(`/api/files/${fileId}`);
};

const shareFileByUser = (fileId,sharedBy,userId) => {
  console.log("shareFileByUser load",fileId,sharedBy,userId)
  return httpcommonFile.post(`/api/files/${fileId}/share/new?sharedBy=${sharedBy}&userId=${userId}`);
};
const shareFileByGruop = (fileId,groupId,useridId) => {
  console.log("shareFileByGruop load",fileId,groupId,useridId)
  return httpcommonFile.post(`/api/files/${fileId}/share/group?sharedBy=${useridId}&groupId=${groupId}`);
};


const FileService = {
  myFiles,
  deleteFiles,
  shareFileByUser,
  shareFileByGruop
};

export default FileService;
